<template>
  <DrawHistoryActivityList />
</template>

<script>
import DrawHistoryActivityList from "../components/place/drawactivity/HistoryActivityList.vue";
export default {
  data() {
    return {};
  },
  components: {
    DrawHistoryActivityList,
  },
};
</script>
<style lang="" scoped></style>
